import styled from '@emotion/styled';
import { Icon } from '@innovamat/glimmer-components';

type ExpandButtonProps = {
  onRowClick: () => void;
  isExpanded: boolean;
};

const Button = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${({ theme }) =>
      theme.tokens.color.alias.cm.bg['bg-neutral-subtle'].value};
  }

  &:focus {
    outline: none;
  }
`;

function ExpandButton({
  onRowClick,
  isExpanded,
}: ExpandButtonProps): JSX.Element {
  const handleClick = () => {
    onRowClick();
  };

  return (
    <Button
      onClick={handleClick}
      aria-label={isExpanded ? 'Collapse row' : 'Expand row'}
    >
      <Icon
        icon="ExpandMoreIcon"
        size="S"
        style={{
          transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
          transition: 'transform 0.2s ease-in-out',
        }}
      />
    </Button>
  );
}

export { ExpandButton };
